// removed by extract-text-webpack-plugin
module.exports = {"List":"_2m75ebHzfLg7a0lpnCv6Pr","Header":"_18zrntQopOuwnWD-N0TrGD","green":"mAZUdkJqXFgsSkfNectab","orange":"_2UBF7eZALHphLwSfMQbiG8","red":"_3uhLwH0YlFcuwKG0GI6gL1","ViewLink":"_3_fp-YMIYxnFaQ4bIbHJdg","Row":"_1AL9rLub6wMAVrTKAIpaZZ","TotalColumn":"_2zMlWV5wkd7cQlregRizHS","CommentColumn":"_3Q6EluWQgPzp5nb9KLEEZX","CommentContainer":"cAL1XrPqJRulRzOwoG4Qw","CommentTooltip":"_209OdooAFzVGs0p9JNEANQ","CommentIcon":"_2knZntn9DnsZ3M3PEJQYKZ"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/WeeklyPayReport/index.css
// module id = 941
// module chunks = 0